import type { IInventoryAdapter } from '../../IInventoryAdapter'
import type { InventoryError, InventoryItem, InventoryItemPage } from '../../types'

export class ZohoInventoryAdapter implements IInventoryAdapter {
  async listCompositeItems(params: { cursor?: string }): Promise<InventoryItemPage> {
    try {
      // Reference param to satisfy no-unused-vars even if unused for now
      void params?.cursor
      const res = await fetch('/api/inventory/items')
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data: unknown = await res.json()
      // Basic shape validation/fallback
      const itemsArray = (data as Record<string, unknown>)?.items
      const items: InventoryItem[] = Array.isArray(itemsArray) ? (itemsArray as InventoryItem[]) : []
      return { items, nextCursor: undefined }
    } catch (e) {
      throw this.normalizeError(e)
    }
  }

  async listAllItems(params: { cursor?: string }): Promise<InventoryItemPage> {
    try {
      // Reference param to satisfy no-unused-vars even if unused for now
      void params?.cursor
      const url = new URL('/api/inventory/items', window.location.origin)
      url.searchParams.set('kind', 'item')
      const res = await fetch(url.toString())
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data: unknown = await res.json()
      const itemsArray = (data as Record<string, unknown>)?.items
      const items: InventoryItem[] = Array.isArray(itemsArray) ? (itemsArray as InventoryItem[]) : []
      return { items, nextCursor: undefined }
    } catch (e) {
      throw this.normalizeError(e)
    }
  }

  async getItemById(externalId: string, options?: { kind?: 'item' | 'composite' }): Promise<InventoryItem> {
    try {
      const url = new URL(`/api/inventory/items/${encodeURIComponent(externalId)}`, window.location.origin)
      if (options?.kind) {
        url.searchParams.set('kind', options.kind)
      }
      const res = await fetch(url.toString())
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const json: unknown = await res.json()
      return json as InventoryItem
    } catch (e) {
      throw this.normalizeError(e)
    }
  }

  async getStockLevels(itemIds: string[]): Promise<Record<string, number>> {
    // TODO: call server route /api/inventory/stock?ids=...
    // Reference param to avoid unused warning until implemented
    void itemIds
    return {}
  }

  normalizeError(error: unknown): InventoryError {
    const message = error instanceof Error ? error.message : String(error)
    return { code: 'ZOHO_ERROR', message }
  }
}

